<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-12 col-lg-8">

      <div class="card">
        <div class="card-body text-center">

          <div class="mb-4">
            <i class="fas fa-check-circle text-success fa-4x"></i>
          </div>

          <h2 class="text-success">
            {{ 'PAYMENT_SUCCESSFUL' | translate }}</h2>

          <hr>

          <p>
            {{ 'YOUR_PAYMENT_HAS_BEEN_RECEIVED_AND_YOUR_FORM_WAS_SUCCESSFULLY_SUBMITTED' | translate }}</p>

          <div
            class="alert alert-success mt-4"
            *ngIf="formTransactionId">

            {{ 'CONFIRMATION_NUMBER' | translate }}<strong>
              {{ 'TR_VALUE0' | translate:{value0:(formTransactionId)} }}</strong>

          </div>

          <p class="mt-3">
            {{ 'A_CONFIRMATION_EMAIL_WILL_BE_SENT_IF_CONFIGURED_BY_THE_CHURCH' | translate }}</p>

          <!-- <a
            class="btn btn-primary mt-3 text-light"
            (click)="goHome()">
            Return Home
          </a> -->

        </div>
      </div>

    </div>
  </div>
</div>